// Role helpers used across the shell. super_admin is treated as a wildcard —
// they can see and act on every queue.
// Phase 7.5 — `is_super_admin` auxiliary flag ALSO grants super powers
// without displacing the user's primary role (e.g. CAO stays admin1_alt).
export const isSuperAdmin = (u) => u?.role === "super_admin" || !!u?.is_super_admin;
export const isHod = (u) => u?.role === "hod";
export const isAnyAdmin = (u) => isSuperAdmin(u) ||
  ["admin1", "admin1_alt", "admin2"].includes(u?.role);
export const isProcessOwner = (u) => u?.role === "process_owner";
export const canSeeAnalytics = (u) => isSuperAdmin(u) ||
  ["admin1", "admin1_alt", "admin2"].includes(u?.role);

// Explicit visibility gates for the queue routes.
export const canAccessHod = (u) => isSuperAdmin(u) || isHod(u);
export const canAccessAdmin = (u) => isSuperAdmin(u) || isAnyAdmin(u);
export const canAccessProcessOwner = (u) => isSuperAdmin(u) || isProcessOwner(u);

// Phase 14 — Analytics trackers (per-owner access gates).
export const canSeeTransportTracker = (u) =>
  isSuperAdmin(u) || (u?.email || "").toLowerCase() === "shivmohan.v@mitgurukul.com";
export const canSeeGuestTracker = (u) =>
  isSuperAdmin(u) || (u?.email || "").toLowerCase() === "bursar@mitgurukul.com";
// Phase 18 (item 3) — Cake / F&B tracker is scoped to Sandeep + super_admin.
export const canSeeFnbTracker = (u) =>
  isSuperAdmin(u) || (u?.email || "").toLowerCase() === "sandeep.singh@mitgurukul.com";
// Phase 21 (item 6) — Print Job tracker is scoped to Print PO + super_admin.
export const canSeePrintJobTracker = (u) =>
  isSuperAdmin(u) || (u?.email || "").toLowerCase() === "print.job@mitgurukul.com";

// Manual follow-up TAT options. `hours` is working-hours passed to the
// backend (which respects Mon–Fri 08:00–16:00 IST plus Indian holidays).
// Label captures the user-facing wording verbatim.
export const MANUAL_TAT_OPTIONS = [
  { key: "none",   label: "None (no follow-up reminder)", hours: null },
  { key: "4h",     label: "4 hours",                       hours: 4 },
  { key: "8h",     label: "8 hours (1 working day)",       hours: 8 },
  { key: "1d",     label: "1 day",                         hours: 8 },
  { key: "2d",     label: "2 days",                        hours: 16 },
  { key: "3d",     label: "3 days",                        hours: 24 },
  { key: "5d",     label: "5 days",                        hours: 40 },
  { key: "1w",     label: "1 week",                        hours: 40 },
];

// Return the working-hours to pass to the backend for a given key.
export const tatHoursFor = (key) => {
  const opt = MANUAL_TAT_OPTIONS.find((o) => o.key === key);
  return opt?.hours ?? null;
};
